import { fetchApi } from '../utils/fetchApi'

export const createRequest = ({ path, preParams }) => ({ params } = {}) => fetchApi({
  body: { ...preParams, ...params },
  path,
})
